// רשימות — every task that holds a tracking list (migration 078), grouped by client the way
// the board groups tasks. Open lists by default, the done ones a click away; all of them or
// only mine. A line opens the same panel the board's strip does. The list still lives in its
// task: this screen gathers, it creates nothing of its own.
import { useState } from 'react';
import he from '../../i18n/he';
import useAsync from '../../hooks/useAsync';
import { taskListsApi } from '../../api';
import PageHeader from '../../components/PageHeader';
import AsyncBoundary from '../../components/Loader';
import EmptyState from '../../components/EmptyState';
import Button from '../../components/Button';
import ListLines from '../../components/lists/ListLines';
import ListPanel from '../../components/lists/ListPanel';
import { taskClient, INTERNAL_KEY } from '../../utils/taskClient';

// Internal tasks' lists (no client) are one "פנימי" group, first — the board's order.
const byClient = (rows) => {
  const groups = new Map();
  for (const r of rows) {
    const key = r.client_id ?? INTERNAL_KEY;
    if (!groups.has(key)) {
      const c = taskClient(r.client_id == null ? null : { id: r.client_id, name: r.client_name, color: r.client_color });
      groups.set(key, { key, ...c, rows: [] });
    }
    groups.get(key).rows.push(r);
  }
  const all = [...groups.values()];
  return [...all.filter((g) => g.key === INTERNAL_KEY), ...all.filter((g) => g.key !== INTERNAL_KEY)];
};

export default function Lists() {
  const [status, setStatus] = useState('open');
  const [mine, setMine] = useState(false);
  const [panelFor, setPanelFor] = useState(null);
  const { data, loading, error, reload } = useAsync(() => taskListsApi.index({ status, mine }), [status, mine]);
  const groups = byClient(data || []);

  return (
    <>
      <PageHeader title={he.lists.nav} spread>
        <div className="seg">
          <Button small variant={status === 'open' ? '' : 'subtle'} onClick={() => setStatus('open')}>{he.lists.openTab}</Button>
          <Button small variant={status === 'done' ? '' : 'subtle'} onClick={() => setStatus('done')}>{he.lists.doneTab}</Button>
        </div>
        <div className="seg">
          <Button small variant={mine ? 'subtle' : ''} onClick={() => setMine(false)}>{he.board.all}</Button>
          <Button small variant={mine ? '' : 'subtle'} onClick={() => setMine(true)}>{he.board.mine}</Button>
        </div>
      </PageHeader>

      <AsyncBoundary loading={loading} error={error}>
        {data && (groups.length === 0
          ? <EmptyState text={status === 'open' ? he.lists.emptyOpen : he.lists.emptyDone} />
          : groups.map((g) => (
            <div key={g.key} className="client-group card" style={{ borderInlineStartColor: g.color || 'var(--border)' }}>
              <div className="group-header">
                <span className="group-toggle list-group-name">
                  <span className="swatch" style={{ background: g.color || 'var(--muted)' }} />
                  <h2>{g.name}</h2>
                </span>
              </div>
              <ListLines rows={g.rows} onOpen={setPanelFor} withJob />
            </div>
          )))}
      </AsyncBoundary>

      {panelFor && <ListPanel taskId={panelFor} onClose={() => { setPanelFor(null); reload(); }} onChanged={reload} />}
    </>
  );
}
